import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { updateField } from './updateField';
export const removeOption = (options, selectedOptions) => idx => {
  const value = options[idx].value;
  const updatedOptions = options.filter(option => option.value !== value);
  const updatedSelectedOptions = selectedOptions.filter(option => option !== value);
  return {
    updatedOptions,
    updatedSelectedOptions
  };
};
export const handleRemoveOption = ({
  idx,
  options,
  formField,
  selectedOptions = [],
  setOptions = () => {},
  handleUpdate = () => {},
  setSelectedOptions = () => {}
}) => {
  const {
    updatedOptions,
    updatedSelectedOptions
  } = removeOption(options, selectedOptions)(idx);
  let updatedSelectedOptionsWithDefault;
  switch (formField.fieldType) {
    case FieldTypes.PAYMENT_RADIO:
      if (updatedOptions.length === 1) {
        updatedSelectedOptionsWithDefault = [updatedOptions[0].value];
      } else {
        updatedSelectedOptionsWithDefault = updatedSelectedOptions;
      }
      break;
    default:
      updatedSelectedOptionsWithDefault = updatedSelectedOptions;
  }
  setOptions(updatedOptions);
  setSelectedOptions(updatedSelectedOptionsWithDefault);
  handleUpdate(updateField(updateField(formField, 'options', updatedOptions), 'selectedOptions', updatedSelectedOptionsWithDefault));
};